<template>
    <a-modal 
    :title="info.isAdd ? '新建任务':'修改任务'" 
    v-model:visible="info.isShow" 
    :footer="null"
    @cancel="cancel" 
    style="min-width: 800px"
    >
        <a-form :model="beanform" ref="beanform" :rules="rule4">
            <a-form-item label="bean名称" name="beanName" :label-col="{ span: 3, offset: 2 }" :wrapper-col="{ span: 14 }">
                <a-input v-model:value="beanform.beanName" placeholder="spring bean名称,如:testTask" allow-clear></a-input>
            </a-form-item>
            <a-form-item label="参数" name="params" :label-col="{ span: 3, offset: 2 }" :wrapper-col="{ span: 14 }">
                <a-input v-model:value="beanform.params" placeholder="参数" allow-clear></a-input>
            </a-form-item>
            <a-form-item label="cron表达式" name="cronExpression" :label-col="{ span: 3, offset: 2 }" :wrapper-col="{ span: 14 }">
                <a-input v-model:value="beanform.cronExpression" placeholder="如:0 0/12 * * ?" allow-clear></a-input>
            </a-form-item>
            <a-form-item label="备注" name="remark" :label-col="{ span: 3, offset: 2 }" :wrapper-col="{ span: 14 }">
                <a-input v-model:value="beanform.remark" placeholder="备注" allow-clear></a-input>
            </a-form-item>
            <a-form-item :wrapper-col="{ offset: 8 }">
                <a-button style="margin-right:100px" @click="reset">重置</a-button>
                <a-button type="primary" @click="onSubmit" v-if="isShowBtn('sys:schedule:save')" >提交</a-button>
            </a-form-item>
        </a-form>
    </a-modal>
</template>
<script>
let defaultform = {
    beanName: "",
    createTime: "2021-01-15 01:51:30",
    cronExpression: "",
    jobId: 0,
    params: "",
    remark: "",
    status: 0
}
let resetform = {...defaultform}
import {saveSchedule,updateSchedule} from "@/api/schedule"
import { message } from 'ant-design-vue';
import { mapActions } from 'vuex';
import { isShowBtn } from "@/until/tool";
export default {
  name: '',
  props: {
      info:{
          type:Object,
          default(){
              return {
                isAdd:true,
                isShow:false
              }
          }
      },
      
  },
  data() {
    return {
        beanform:{
            beanName: "",
            createTime: "2021-01-15 01:51:30",
            cronExpression: "",
            jobId: 0,
            params: "",
            remark: "",
            status: 0
        },
        rule4:{
          beanName:[{ required: true, message: 'bean名称不能为空', trigger: 'blur' },],
          cronExpression:[{ required: true, message: 'cron表达式不能为空', trigger: 'blur' },]
      }
    };
  },
  created(){},
  computed: {},
  watch: {},
  methods: {
      isShowBtn,
      ...mapActions({
        QuerySchedulePage:"schedule/QuerySchedulePage",
      }),
      cancel(){
        this.beanform = {...resetform}

      },
      reset(){
        if(this.info.isAdd){ // 添加时候的重置！
            this.beanform = {...resetform}
        }else{ // 修改时候的重置！
            // this.setinfo({...defaultItem})
          this.beanform = {...defaultform}
        }
      },
      setinfo(val){
          defaultform = {...val}
          this.beanform = {...val}
      },
      onSubmit(){
          this.$refs.beanform.validate().then(async()=>{
              let res
            if(this.info.isAdd){ 
                 res = await saveSchedule(this.beanform)
                    
            }else{
                res = await updateSchedule(this.beanform)
            }
            if(res && res.code==0){
                message.success('新增/修改任务成功')
                this.info.isShow = false;
                this.QuerySchedulePage();  // 再次获取列表，让仓库里面的数据是最新的！
                this.cancel();
            }else{
                message.error('新增/修改任务失败')
            }
          })
        
      }
  },
  components: {},
  filters: {}
};
</script>
<style lang='scss' scoped>
</style>